var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingboxv1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shipping_box_v1",
    "data-name": "shipping box v1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.402,
    height: 46.402,
    viewBox: "0 0 46.402 46.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26949",
    "data-name": "Trac\\xE9 26949",
    d: "M21.525,5.063a3.863,3.863,0,0,1,3.751,0l14.53,8.072a1.92,1.92,0,0,1,1,1.692V30.749a3.856,3.856,0,0,1-1.991,3.374L25.276,41.644a3.863,3.863,0,0,1-3.751,0L7.991,34.123A3.856,3.856,0,0,1,6,30.749V14.827a1.92,1.92,0,0,1,1-1.692Z",
    transform: "translate(-0.2 -0.152)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26950",
    "data-name": "Trac\\xE9 26950",
    d: "M6,14l17.4,9.667m0,0L40.8,14M23.4,23.667V42.035",
    transform: "translate(-0.2 -0.466)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26951",
    "data-name": "Trac\\xE9 26951",
    d: "M15,18.667,32.4,9",
    transform: "translate(-0.499 -0.3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26952",
    "data-name": "Trac\\xE9 26952",
    d: "M12,24.66l5.8,3.229",
    transform: "translate(-0.399 -0.821)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26953",
    "data-name": "Trac\\xE9 26953",
    d: "M0,0H46.4V46.4H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingboxv1);
export default __webpack_public_path__ + "static/media/shipping box v1.a9734cb0a87a0fad0ba8336bc5a75b74.svg";
export { ForwardRef as ReactComponent };